import useEffectOnce from './use-effect-once';

type UseHubSpotUnreadListenerProps = {
  callback: (hasUnreadConversations: boolean) => void;
};

export const useHubSpotUnreadListener = ({ callback }: UseHubSpotUnreadListenerProps) => {
  useEffectOnce(() => {
    window?.HubSpotConversations?.on('unreadConversationCountChanged', (payload) => {
      if (payload?.unreadCount !== undefined) {
        callback(payload.unreadCount > 0);
      }
    });

    return () => {
      window?.HubSpotConversations?.off('unreadConversationCountChanged', () => {});
    };
  });
};
